import React from 'react'
import { Icon, IconType } from '../Icon'
import { colors } from '../colors'
import { StatusIconContainer } from './StatusIcon.styles'
import { ItemStatus } from '../../../api/documentation/types/model'

export type StatusType = 'received' | 'expected' | 'not-provided'
export type StatusVariant = 'card' | 'table'

interface StatusIconProps {
  status: ItemStatus
  isCompact?: boolean
  size?: number
  variant?: StatusVariant
  onClick: () => void
}

export const StatusIcon: React.FC<StatusIconProps> = ({ 
  status, 
  isCompact = false,
  size = 16,
  variant = 'card',
  onClick
}) => {
  const getStatusData = (status: ItemStatus) => {
    switch (status) {
      case 0:
        return {
          icon: 'check' as IconType,
          bgColor: colors.status.received.icon
        }
      case 1:
        return {
          icon: 'exclamation' as IconType,
          bgColor: colors.status.expected.icon
        }
      case 2:
      default:
        return {
          icon: 'circle' as IconType,
          bgColor: colors.status.notProvided.icon
        }
    }
  }

  const { icon, bgColor } = getStatusData(status)

  return (
    <StatusIconContainer bg={bgColor} isCompact={isCompact} variant={variant} onClick={onClick}>
      <Icon type={icon} size={size} color="white" />
    </StatusIconContainer>
  )
}
